import React from 'react';
import PropTypes from 'prop-types';
import BootstrapCard from "shared/components/bootstrapCard/BootstrapCard";
import SovosEditableSlidingPanel from 's1-ui/sovos-sliding-panel/SovosEditableSlidingPanel';
import ProfileRulesManagement from './comp/profileRulesManagement/ProfileRulesManagement';
import { slidingPanelTitleGray } from 'theme/mainColors';
import { RULE_PROP_TYPE } from 'shared/constants/PropTypes';
import {
  SLIDING_PANEL_DIALOG_ACTION_LABEL,
  SLIDING_PANEL_DIALOG_CONTENT_CLASS_NAME,
  SLIDING_PANEL_DIALOG_TEXT,
  SLIDING_PANEL_DIALOG_TITLE,
  SLIDING_PANEL_DIALOG_TITLE_CLASS_NAME
} from 'shared/constants/SharedConstants';

class RulesPanel extends React.Component {
  state = {
    openRulesPanel: false,
    applyButtonDisabled: true
  };

  handleRulesPanelOpen = () => {
    this.props.rulesActions.backupRules();
    this.setState({ openRulesPanel: true });
  };

  handleRulesPanelClose = () => {
    this.props.rulesActions.restoreRules();
    this.setState({ openRulesPanel: false });
  };

  handleApplyRules = () => {
    this.props.profilesActions.addRuleIdsToProfile(this.props.orderedRules.map(rule => rule.id ));
    this.setState({ openRulesPanel: false });
  };

  render() {
    const { profileRules, orderHasChanged, loading } = this.props;
    return (
      [
        <BootstrapCard 
          title="6. Data Enrichment & Validation Rules" 
          key="manageRulesCard" 
          loading={ loading }
          margin={ '15px 0' }
        >
          <div className="manage-imp-profile__column-mapping-text">{ profileRules.ruleIds.length === 0 ? 'No rules applied' : `${profileRules.ruleIds.length} Rules currently applied` }</div>
          <div className="manage-imp-profile__column-mapping-open" onClick={ this.handleRulesPanelOpen }>Manage Rules</div>
        </BootstrapCard>,
        <SovosEditableSlidingPanel
          title="Data Enrichment"
          className="rules-sliding-panel"
          key="manageRulesSlidingPanel"
          isDirty={ () => true }
          titleStyle={ { color: slidingPanelTitleGray } }
          open={ this.state.openRulesPanel }
          onClose={ this.handleRulesPanelClose }
          showCloseButton={ false }
          baseWidth={ '1080px' }
          SaveButtonProps={ {
            disabled: !orderHasChanged,
            children: 'APPLY',
            onClick: this.handleApplyRules,
            className: 'column-mapping__button'
          } }
          CancelButtonProps={ {
            className: 'column-mapping__button',
            children: 'CANCEL'
          } }
          CloseDialogProps={ {
            DialogTitleProps: {
              children: SLIDING_PANEL_DIALOG_TITLE,
              className: SLIDING_PANEL_DIALOG_TITLE_CLASS_NAME
            },
            DialogContentProps: {
              children: SLIDING_PANEL_DIALOG_TEXT,
              className: SLIDING_PANEL_DIALOG_CONTENT_CLASS_NAME
            },
            OKButtonProps: {
              children: SLIDING_PANEL_DIALOG_ACTION_LABEL
            },
            CancelButtonProps: {
              children: 'CANCEL'
            }
          } }
        >
          <div>
            <ProfileRulesManagement />
          </div>
        </SovosEditableSlidingPanel>
      ]
    );
  }
}

RulesPanel.propTypes = {
  rules: PropTypes.arrayOf(RULE_PROP_TYPE).isRequired,
  orderedRules: PropTypes.arrayOf(RULE_PROP_TYPE).isRequired,
  orderHasChanged: PropTypes.bool.isRequired,
  profileRules: PropTypes.object,
  fetchingRules: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  rulesActions: PropTypes.shape({
    restoreRules: PropTypes.func,
    backupRules: PropTypes.func
  }).isRequired,
  profilesActions: PropTypes.shape({
    addRuleIdsToProfile: PropTypes.func
  }).isRequired
};

RulesPanel.defaultProps = {
  loading: false
};

export default RulesPanel;



// WEBPACK FOOTER //
// ./src/components/importProfile/comp/rulesPanel/RulesPanel.js